// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-Home-Main-cards-root-oL8lU","card":"src-components-Home-Main-cards-card-1EzgH","image":"src-components-Home-Main-cards-image-2zs1u","overlay":"src-components-Home-Main-cards-overlay-3lTU9","content":"src-components-Home-Main-cards-content-kYvuq","count":"src-components-Home-Main-cards-count-25kWX"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Home/Main/cards.css
 ** module id = 269
 ** module chunks = 0
 **/